export default __webpack_public_path__ + "static/kim-b60875e838eaeafc29ae9803aabece73.webp";